

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;




//////////////////
// WEBPACK FOOTER
// ../node_modules/gopd/index.js
// module id = ../node_modules/gopd/index.js
// module chunks = 1